module.exports = __webpack_public_path__ + "static/media/Chinmay_Sheth.4d5c7dea.jpg";